import { startOfWeek, startOfMonth, subMonths, startOfDay, addMonths, addWeeks, addDays } from 'date-fns';
const noFilterObj = {
  fromDate: null,
  toDate: null
};
export function getFormattedTimeRange(preset, now) {
  switch (preset) {
    case 'all-time':
      return noFilterObj;
    case 'today':
      {
        const from = startOfDay(now);
        return {
          fromDate: from.getTime(),
          toDate: addDays(from, 1).getTime()
        };
      }
    case 'this-week':
      {
        const from = startOfWeek(now);
        return {
          fromDate: from.getTime(),
          toDate: addWeeks(from, 1).getTime()
        };
      }
    case 'this-month':
      {
        const from = startOfMonth(now);
        return {
          fromDate: from.getTime(),
          toDate: addMonths(from, 1).getTime()
        };
      }
    case 'previous-month':
      {
        const to = startOfMonth(now);
        return {
          fromDate: subMonths(to, 1).getTime(),
          toDate: to.getTime()
        };
      }
    case 'last-three-months':
      {
        const to = startOfMonth(now);
        return {
          fromDate: subMonths(to, 3).getTime(),
          toDate: to.getTime()
        };
      }
  }
}
export function isInRange(rangeObj, dateObj) {
  const timestamp = dateObj.getTime();
  return (rangeObj.fromDate || -Infinity) <= timestamp && timestamp <= (rangeObj.toDate || Infinity);
}